module.exports = __webpack_public_path__ + "img/WA.bb41b6a.png";